import React from 'react';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import { useApi } from '../../context/api-context/use-api';
import { RatingsInput } from 'wix-ui-tpa/cssVars';
import { StarIcon } from '../icons/star-icon';
import { COMMENT_BOX_PLACEHOLDER, RATING_INPUT } from '../../../common/constants/data-hooks';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { formatLabel, getPlaceholderKey } from './comment-box.utils';
import { PlaceholderText } from './placeholder-text/placeholder-text';
import { st, classes } from './comment-box.st.css';
export const DummyCommentBox = ({ onClick, className, }) => {
    const { placeholderText, ratings } = useConfiguration();
    const [interactionState, setInteractionState] = React.useState('default');
    const { isMobile } = useApi((state) => ({
        isMobile: getIsMobile(state),
    }));
    const t = useTranslate();
    return (React.createElement("div", { className: st(classes.root, { isMobile }, className), style: { cursor: 'pointer' }, onClick: onClick },
        React.createElement("div", { className: st(classes.contentContainer, {
                isHighlighted: interactionState !== 'default',
            }), onMouseEnter: () => setInteractionState('hover'), onMouseLeave: () => setInteractionState('default') },
            ratings && !isMobile ? (React.createElement("div", { className: classes.ratingInputContainer },
                React.createElement(RatingsInput, { className: classes.ratingInput, "data-hook": RATING_INPUT, value: undefined, label: formatLabel(t('comment-box.add-a-rating'), ratings.isRequired), labelLayout: isMobile ? 'labelTop' : 'labelAside', size: isMobile ? 'large' : 'small', disabled: true }))) : null,
            React.createElement("button", { "data-hook": COMMENT_BOX_PLACEHOLDER, className: classes.placeholder },
                ratings && isMobile ? React.createElement(StarIcon, { className: classes.starIcon }) : null,
                React.createElement(PlaceholderText, { text: placeholderText ??
                        t(getPlaceholderKey({
                            isExpanded: false,
                            isReply: false,
                            withRating: Boolean(ratings),
                            isMobile,
                        })) })))));
};
//# sourceMappingURL=dummy-comment-box.js.map